var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_1284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0167 18.1497L12.7815 12.5365C13.8135 11.2103 14.4343 9.51556 14.4343 7.66453C14.4343 3.44162 11.1997 0.00799561 7.22089 0.00799561C3.24211 0.00799561 0 3.44562 0 7.66853C0 11.8914 3.23463 15.3251 7.21341 15.3251C8.90364 15.3251 10.4593 14.7041 11.6933 13.6664L16.9472 19.2956C17.2538 19.6241 17.7101 19.6241 18.0167 19.2956C18.3233 18.967 18.3233 18.4782 18.0167 18.1497ZM1.53318 7.66853C1.53318 4.3511 4.08348 1.65469 7.21341 1.65469C10.3433 1.65469 12.8936 4.3511 12.8936 7.66853C12.8936 10.986 10.3433 13.6824 7.21341 13.6824C4.08348 13.6824 1.53318 10.982 1.53318 7.66853Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_1284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2467,
    height: 19.55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e51a56c3.svg";
export { ForwardRef as ReactComponent };